/**
 * @generated SignedSource<<88f3e844f58e542990a179df6414d806>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveIncludeDispatchConditionInput = {
  clientMutationId?: string | null;
  dispatchConditionId: string;
  messageDispatchId: string;
};
export type removeDispatchConditionButton_RemoveIncludeDispatchConditionMutation$variables = {
  input: RemoveIncludeDispatchConditionInput;
};
export type removeDispatchConditionButton_RemoveIncludeDispatchConditionMutation$data = {
  readonly Admin: {
    readonly Message: {
      readonly removeIncludeDispatchCondition: {
        readonly messageDispatch: {
          readonly id: string;
        };
      } | null;
    };
  };
};
export type removeDispatchConditionButton_RemoveIncludeDispatchConditionMutation = {
  response: removeDispatchConditionButton_RemoveIncludeDispatchConditionMutation$data;
  variables: removeDispatchConditionButton_RemoveIncludeDispatchConditionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Message",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "RemoveIncludeDispatchConditionPayload",
            "kind": "LinkedField",
            "name": "removeIncludeDispatchCondition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MessageDispatch",
                "kind": "LinkedField",
                "name": "messageDispatch",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "removeDispatchConditionButton_RemoveIncludeDispatchConditionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "removeDispatchConditionButton_RemoveIncludeDispatchConditionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fbb6249c4ef76343a87846f907080d20",
    "id": null,
    "metadata": {},
    "name": "removeDispatchConditionButton_RemoveIncludeDispatchConditionMutation",
    "operationKind": "mutation",
    "text": "mutation removeDispatchConditionButton_RemoveIncludeDispatchConditionMutation(\n  $input: RemoveIncludeDispatchConditionInput!\n) {\n  Admin {\n    Message {\n      removeIncludeDispatchCondition(input: $input) {\n        messageDispatch {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "575555965f95e1c741868e59ee69ee48";

export default node;
